import * as React from 'react';

const SvgClipboard = (props) => (
  <svg
    width={56}
    height={56}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M33.486 4.667H22.519c-2.426 0-4.41 1.96-4.41 4.386v2.194a4.382 4.382 0 0 0 4.387 4.386h10.99a4.382 4.382 0 0 0 4.387-4.386V9.053c.023-2.426-1.96-4.386-4.387-4.386Z'
      fill='#E00034'
    />
    <path
      d='M40.23 11.247c0 3.71-3.034 6.743-6.744 6.743H22.52c-3.71 0-6.744-3.033-6.744-6.743 0-1.307-1.4-2.124-2.566-1.517a10.434 10.434 0 0 0-5.53 9.217v21.956c0 5.74 4.69 10.43 10.43 10.43h19.786c5.74 0 10.43-4.69 10.43-10.43V18.947c0-3.99-2.24-7.467-5.53-9.217-1.166-.607-2.566.21-2.566 1.517Zm-4.434 18.456-9.333 9.334a1.73 1.73 0 0 1-1.237.513 1.73 1.73 0 0 1-1.236-.513l-3.5-3.5a1.76 1.76 0 0 1 0-2.474 1.76 1.76 0 0 1 2.473 0l2.263 2.264 8.097-8.097a1.76 1.76 0 0 1 2.473 0 1.76 1.76 0 0 1 0 2.473Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgClipboard;
